import React, { useState, useEffect } from "react";
import "../selfcss/bookingModal.css";
import emailjs from "emailjs-com";

const BookingModal = ({ tripDetails, vehicle, onClose }) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
  });

  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    const { name, email, phone } = formData;
    const phoneRegex = /^[6-9]\d{9}$/;
    setIsFormValid(
      name.trim() !== "" &&
      email.trim() !== "" &&
      phoneRegex.test(phone)
    );
  }, [formData]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleBookNow = async () => {
    if (!isFormValid) {
      alert("Please fill in all the required fields correctly.");
      return;
    }

    // EmailJS configuration
    const serviceID = "service_hil6pea"; 
    const ownerTemplateID = "template_qhnfygp"; // Replace with your EmailJS template ID for the owner
    const customerTemplateID = "template_40l7tch"; // Replace with your EmailJS template ID for the customer
    const userID = "hSBjC7cjuzWyuOdYr"; // Replace with your EmailJS user ID

    // Data to send in the email
    const emailData = {
      customer_name: formData.name,
      customer_email: formData.email,
      customer_phone: formData.phone,
      trip_type: vehicle.tripType,
      pickup: tripDetails.source,
      drop: tripDetails.destination,
      departure_date: tripDetails.departureDate,
      return_date: tripDetails.arrivalDate || "N/A",
      persons: tripDetails.persons,
      vehicle_name: vehicle.name,
      vehicle_passengers: vehicle.specs.passengers,
      vehicle_ac: vehicle.specs.airConditioning,
      vehicle_per_km: vehicle.specs.perKmCharge,
      vehicle_toll_tax: vehicle.specs.tollTax,
    };

    try {
      // Send email to the owner
      await emailjs.send(serviceID, ownerTemplateID, emailData, userID);
      console.log("Email sent to the owner.");

      // Send email to the customer
      await emailjs.send(serviceID, customerTemplateID, emailData, userID);
      alert("Booking Is In Process!! We will Reach Out To You Shortly.");
      onClose(); // Close the modal
    } catch (error) {
      console.error("Failed to send email:", error);
      alert("Failed to send email. Please try again later.");
    }
  };
  return (
    <div className="booking-modal">
      <div className="modal-body">
        <button className="close-button" onClick={onClose}>
          &times;
        </button>

        <div className="form-section">
          <h5>Enter Your Details</h5>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            placeholder="Enter your name"
            required
          />
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            placeholder="Enter your email"
            required
          />
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
            placeholder="Enter your phone number"
            required
          />
          <img
            src="assets/img/bookingModal/kotharitaxi.png"
            alt="Vehicle"
            className="form-image"
          />
        </div>

        <div className="details-section">
          <h5>Trip Details</h5>
          {vehicle.tripType === "one-way" ? (
            <div>
              <p><strong>Trip Type:</strong> {vehicle.tripType}</p>
              <p><strong>Pickup:</strong> {tripDetails.source}</p>
              <p><strong>Drop:</strong> {tripDetails.destination}</p>
              <p><strong>Date:</strong> {tripDetails.departureDate}</p>
              <p><strong>Persons:</strong> {tripDetails.persons}</p>
            </div>
          ) : (
            <div>
              <p><strong>Trip Type:</strong> {vehicle.tripType}</p>
              <h6>Outbound</h6>
              <p><strong>Pickup:</strong> {tripDetails.source}</p>
              <p><strong>Drop:</strong> {tripDetails.destination}</p>
              <p><strong>Date:</strong> {tripDetails.departureDate}</p>
              <h6>Return</h6>
              <p><strong>Pickup:</strong> {tripDetails.destination}</p>
              <p><strong>Drop:</strong> {tripDetails.source}</p>
              <p><strong>Return:</strong> {tripDetails.arrivalDate}</p>
              <p><strong>Persons:</strong> {tripDetails.persons}</p>
            </div>
          )}

          <h5>Vehicle Details</h5>
          <p><strong>Vehicle:</strong> {vehicle.name}</p>
          <p><strong>Passengers:</strong> {vehicle.specs.passengers}</p>
          <p><strong>AC:</strong> {vehicle.specs.airConditioning}</p>
          <p><strong>Per Km:</strong> {vehicle.specs.perKmCharge}</p>
          <p><strong>Toll Tax:</strong> {vehicle.specs.tollTax}</p>

          <button
            className="btn-book-now"
            onClick={handleBookNow}
            disabled={!isFormValid}
          >
            Book Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default BookingModal;
